/* DeviceConfigurationSnapshotViewRenderer.js */

"use strict";
//const Grid = require('@gluenetworks/steve_ui_widgets').GridGl.Grid;
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const Registrations = require("../../../../../RegistrationNamespaces");
const EditSnapshotComp = require("./subviews/edit_snapshot/EditSnapshotViewComponent");
const _ = require("lodash");

class DeviceConfigurationSnapshotViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("device-configuration-snapshot-view-gl");
        this._rootElem.component = this._model;

        this._defaultViewActive = false;

        this._defaultSnapshotGrid = null;
        this._allSnapshotsGrid = null;

        this._onCaptureButtonClick = this._onCaptureButtonClick.bind(this);
        this._onCompareButtonClick = this._onCompareButtonClick.bind(this);
        this._onDeleteButtonClick = this._onDeleteButtonClick.bind(this);
        this._onSetDefaultSnapshotConfirm = this._onSetDefaultSnapshotConfirm.bind(this);
        this._onDeleteActionConfirm = this._onDeleteActionConfirm.bind(this);

        this._registerViewActions();
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerViewActions() {
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Delete",
            name: "delete_all",
            handler: this._onDeleteButtonClick,
        });

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Compare",
            name: "compare",
            handler: this._onCompareButtonClick,
        });
    }

    _registerGridListeners() {
        this._allSnapshotsGrid.on(
            "UserSorted",
            (this._onGridUserSorted = this._onGridUserSorted.bind(this))
        );
        this._allSnapshotsGrid.on(
            "UserSelectedRows",
            (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this))
        );
        this._allSnapshotsGrid.on(
            "GridAction",
            (this._onGridAction = this._onGridAction.bind(this))
        );
    }

    _registerListeners() {
        this._model.on(
            "DeviceCaptureChange",
            (this._deviceCaptureChange = this._deviceCaptureChange.bind(this))
        );
    }

    _unregisterListeners() {
        if (this._allSnapshotsGrid) {
            this._allSnapshotsGrid.removeAllListeners("UserSorted");
            this._allSnapshotsGrid.removeAllListeners("UserSelectedRows");
            this._allSnapshotsGrid.removeAllListeners("GridAction");
        }
        this._model.removeAllListeners("DeviceCaptureChange");
    }

    _renderGrids() {
        const allSnapshots = this._model.getAllSnapshots(),
            defaultSnapshot = this._model.getDefaultSnapshot(),
            status = this._model._gameEditor._device.discoveryStatus;

        if (!this._allSnapshotsGrid) {
            this._allSnapshotsGrid = new EntityGrid({
                gridKey: this._model._gridKey,
                columns: this._model.columnConfig,
                pagingFeed: this._model._pagingFeed,
                showHeader: true,
            });

            this._allSnapshotsGrid.renderer.rootElement.classList.add("all-snapshots");
            this._rootElem.appendChild(this._allSnapshotsGrid.renderer.rootElement);
            this._registerGridListeners();
        }

        if (Object.keys(allSnapshots).length !== 0 || Object.keys(defaultSnapshot).length) {
            this._hideRunningMessageDisplay();
            this._hideDefaultMessageDisplay();
        } else if (this._model.testCapturing(status)) {
            this._showRunningMessageDisplay();
        } else {
            this._showDefaultMessageDisplay();
        }
    }

    _onDevConfDefaultUpdated(/*devConf*/) {
        //this._defaultSnapshotGrid.setRows(devConf);
        if (this._defaultViewActive === true) {
            this._hideDefaultMessageDisplay();
        }
    }

    _onDeviceConfReset() {
        this._renderGrids();
    }

    _deviceCaptureChange() {
        this._renderGrids();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [];
        if (this._allSnapshotsGrid) {
            promArr.push(this._allSnapshotsGrid.shutdown());
        }

        return Promise.all(promArr).then(
            () => {
                //this._defaultSnapshotGrid = undefined;
                this._allSnapshotsGrid = undefined;
                this._defaultViewActive = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this.model._logger(
                    err,
                    "DeviceConfigurationSnapshotViewRenderer.shutdown() error."
                );
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model
            .whenModelIsReady()
            .then(() => {
                this._model.gameEditor.hideViewAction("compare");
                this._model.gameEditor.hideViewAction("delete_all");
                this._renderGrids();
            })
            .catch((err) => {
                this._model._logger.warn(
                    {error: err},
                    "DeviceConfigurationSnapshotViewRenderer.whenModelIsReady error."
                );
            });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    // TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDefaultSnapshotGridAction(actionData) {
        let defaultSnapshotId = Object.keys(this._model.getDefaultSnapshot())[0],
            action = actionData.eventData.action,
            rowId = actionData.rowId,
            newState;
        switch (action) {
            case "edit":
                newState = _.merge({}, this._model.gameEditor.editorState, {
                    fqn: Registrations.DIE_VIEW_EDIT_SNAPSHOT,
                    breadcrumb: [
                        {
                            value: {
                                fqn: Registrations.DIE_VIEW_SNAPSHOT,
                            },
                            content: "Snapshot",
                            left: {
                                arrow: {
                                    direction: "left",
                                },
                            },
                        },
                    ],
                    viewState: {selectedConfigId: rowId},
                });
                this._model.gameEditor.setEditorState(newState);
                break;
            case "view":
                newState = _.merge({}, this._model.gameEditor.editorState, {
                    fqn: Registrations.DIE_VIEW_CONFIG,
                    breadcrumb: null,
                    viewState: {selectedConfigId: rowId},
                });
                this._model.gameEditor.setEditorState(newState);
                break;
            case "compare":
                newState = _.merge({}, this._model.gameEditor.editorState, {
                    fqn: Registrations.DIE_VIEW_COMPARE,
                    breadcrumb: null,
                    viewState: {defaultSnapshotId: defaultSnapshotId},
                });
                this._model.gameEditor.setEditorState(newState);
                break;
        }
    }

    _onGridUserSorted(sortData) {
        console.info("GRID SORTED: ", sortData);
        this._model.onUserSorted(sortData);
    }

    _onGridUserSelectedRows(selectedRowIds) {
        this._selectedRowId = selectedRowIds[0];
        if (selectedRowIds.length > 1) {
            this._model.gameEditor.showViewAction("delete_all");
            this._model.gameEditor.hideViewAction("compare");
        } else if (selectedRowIds.length === 1) {
            this._model.gameEditor.showViewAction("compare");
            this._model.gameEditor.hideViewAction("delete_all");
        } else {
            this._model.gameEditor.hideViewAction("compare");
            this._model.gameEditor.hideViewAction("delete_all");
        }
    }

    _onGridAction(actionData) {
        let action = actionData.eventData.action,
            rowId = actionData.rowId,
            snapshotRows = this._model._pagingFeed.feed.cache,
            defaultSnapshotId = Object.keys(this._model.getDefaultSnapshot())[0],
            snapshot = snapshotRows[rowId].capturedTime,
            description = snapshotRows[rowId].description,
            backupConfigId = _.get(
                snapshotRows[rowId],
                "pristineProperties.backupConfigurationId",
                null
            ),
            newState;
        snapshot = new Date(snapshot);
        let datelocale = snapshot.toLocaleDateString();
        let timelocale = snapshot.toLocaleTimeString();
        snapshot = datelocale + " " + timelocale;
        let snapshotText;
        switch (action) {
            case "edit":
                this._model._muf
                    .displayCustom(new EditSnapshotComp({captureTime: snapshot, description}))
                    .then((result) => {
                        this._model._pagingFeed.feed.cache[rowId].setDescription(result);
                        return this._model._pagingFeed.feed.cache[rowId].update();
                    })
                    .catch((err) => {
                        this._model._logger.warn("Edit Snapshot Warning :: ", err);
                    });
                break;
            case "view":
                newState = _.merge({}, this._model.gameEditor.editorState, {
                    fqn: Registrations.DIE_VIEW_CONFIG,
                    breadcrumb: null,
                    viewState: {selectedConfigId: rowId},
                });
                this._model.gameEditor.setEditorState(newState);
                break;
            case "compare":
                newState = _.merge({}, this._model.gameEditor.editorState, {
                    fqn: Registrations.DIE_VIEW_COMPARE,
                    breadcrumb: null,
                    viewState: {selectedConfigId: rowId, defaultSnapshotId: defaultSnapshotId},
                });
                this._model.gameEditor.setEditorState(newState);
                break;
            case "delete":
                this.model.gameEditor.runConfirmationActionWorkflow(
                    {
                        message: "Delete configuration snapshot?",
                        title: "Delete",
                        confirmDetails: {
                            text: "Delete",
                            type: "destructive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text",
                        },
                    },
                    this._onDeleteActionConfirm,
                    {
                        message: "Device configuration successfully deleted.",
                        title: "Delete Success",
                    }
                );
                break;
            case "rollback":
                break;
            case "defaultSnapshot":
                snapshotText = "";
                if (description) {
                    snapshotText = snapshot + " - " + description;
                } else {
                    snapshotText = snapshot;
                }
                this.model.gameEditor.runQuickConfirmationActionWorkflow(
                    {
                        message: `Set Configuration Snapshot ${snapshotText} as new default?`,
                        title: "Set Default Configuration",
                        confirmDetails: {
                            text: "Confirm",
                            type: "destructive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text",
                        },
                    },
                    this._onSetDefaultSnapshotConfirm
                );
                break;
            case "restore":
                this._onRestoreBackup(backupConfigId);
                break;
        }
    }

    _onRestoreBackup(backupConfigId) {
        this._model._gameEditor.setActiveView(
            "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Restore",
            [],
            {backupConfigId}
        );
    }

    _onSetDefaultSnapshotConfirm() {
        return this._model
            .setNewDefaultSnapshot(this._allSnapshotsGrid._selectedRows[0])
            .then(() => {
                const s = this._model._pagingFeed.getSort();
                this._model._pagingFeed.setSort();
                this._model._pagingFeed.setSort(this._model._patchSorting(s));
            });
    }

    _onDeleteActionConfirm() {
        const selectedItems =
            this._allSnapshotsGrid._selectedRows && this._allSnapshotsGrid._selectedRows.length > 0
                ? this._allSnapshotsGrid._selectedRows
                : [this._selectedRowId];
        if (selectedItems.length > 0) {
            return Promise.all(
                selectedItems.map((item) => {
                    return this._model.deleteSnapshot(item);
                })
            );
        }
    }

    _onCaptureButtonClick() {
        return this.model.gameEditor.runAction(Registrations.DIE_ACTION_CAPTURE);
    }

    _onCompareButtonClick() {
        if (this._selectedRowId) {
            this._model.gameEditor.setActiveView(Registrations.DIE_VIEW_COMPARE, null, {
                selectedConfigId: this._selectedRowId,
            });
        }
    }

    _onDeleteButtonClick() {
        this.model.gameEditor.runConfirmationActionWorkflow(
            {
                message: "Delete all selected configuration snapshots?",
                title: "Delete Selected",
                confirmDetails: {
                    text: "Delete All",
                    type: "destructive",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            },
            this._onDeleteActionConfirm,
            {
                message: "All device configurations successfully deleted.",
                title: "Delete Success",
            }
        );
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _showDefaultMessageDisplay() {
        this._model.gameEditor
            .showDefaultMessageView({
                message: "Run initial device capture",
                icon: "configdrift.snapshot",
                action: Registrations.DIE_ACTION_CAPTURE,
            })
            .then(() => {
                this._defaultViewActive = true;
            });
    }

    _showRunningMessageDisplay() {
        this._model.gameEditor.showDefaultMessageView({
            message: "Initial device capture is running",
            icon: "common.loading",
        });
    }

    _hideDefaultMessageDisplay() {
        this._model.gameEditor.hideDefaultMessageView().then(() => {
            this._defaultViewActive = false;
        });
    }

    _hideRunningMessageDisplay() {
        this._model.gameEditor.hideDefaultMessageView();
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = DeviceConfigurationSnapshotViewRenderer;
